import { Unit } from '@rematter/frontend-lib-api-client';

export type ItemPositionSortOption =
  | 'IncomingAsc'
  | 'IncomingDesc'
  | 'ItemNameAsc'
  | 'ItemNameDesc'
  | 'NetPositionAsc'
  | 'NetPositionDesc'
  | 'OutgoingAsc'
  | 'OutgoingDesc';

export const enumItemPositionSortOption = {
  IncomingAsc: 'IncomingAsc' as const,
  IncomingDesc: 'IncomingDesc' as const,
  ItemNameAsc: 'ItemNameAsc' as const,
  ItemNameDesc: 'ItemNameDesc' as const,
  NetPositionAsc: 'NetPositionAsc' as const,
  NetPositionDesc: 'NetPositionDesc' as const,
  OutgoingAsc: 'OutgoingAsc' as const,
  OutgoingDesc: 'OutgoingDesc' as const,
};

export type ItemPositionRecord = {
  id: string;
  itemId: string;
  itemName: string;
  itemSku: string;
  facilityId?: string;
  facilityName?: string;
  currentInventory: number;
  incoming: number;
  outgoing: number;
  netPosition: number;
  unit: Unit;
};

export type PositionSummaryStats = {
  totalItems: number;
  negativePositions: number;
  totalIncoming: number;
  totalOutgoing: number;
};
